export default __webpack_public_path__ + "static/media/chen.118811e2.jpg";